/**
 * Utility per la gestione degli URL delle news.
 */

/**
 * Estrae il dominio "leggibile" da un URL, senza il prefisso `www.`.
 *
 * @param {string} url
 * @returns {string} dominio, oppure stringa vuota se l'URL non è valido
 * @example extractDomain('https://www.example.com/a/b') // 'example.com'
 */
export function extractDomain(url) {
  if (typeof url !== 'string' || !url.trim()) return '';

  try {
    const { hostname } = new URL(url);
    return hostname.replace(/^www\./i, '');
  } catch {
    return '';
  }
}

/**
 * Tronca un testo aggiungendo i puntini di sospensione.
 *
 * @param {string} text
 * @param {number} [maxLength=90]
 * @returns {string}
 */
export function truncate(text, maxLength = 90) {
  const value = String(text ?? '');
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1).trimEnd()}…`;
}
